<template>
  <component :is="componentName" />
</template>

<script>
import IconBalloonPresentBox70px from "@/common/components/icons/IconBalloonPresentBox70px.vue";
import IconBalloonPresentBox100px from "@/common/components/icons/IconBalloonPresentBox100px.vue";

export default {
  components: {
    IconBalloonPresentBox70px,
    IconBalloonPresentBox100px
  },

  props: {
    size: {
      type: Number,
      default: 100
    }
  },

  computed: {
    componentName() {
      return `IconBalloonPresentBox${this.size}px`;
    }
  }
};
</script>
